import ApolloClient from 'apollo-client';
import { split } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { WebSocketLink } from 'apollo-link-ws';
import { setContext } from 'apollo-link-context';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { BACKEND_URL, BACKEND_URL_WS } from './back-end-url';

const httpLink = createHttpLink({
  uri: `${BACKEND_URL}/graphql`
});

const wsLink = new WebSocketLink({
  uri: `${BACKEND_URL_WS}/subscriptions`,
  options: {
    reconnect: true
  }
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token || ''
    }
  };
});

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  httpLink
);

export default new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    addTypename: true
  }),
  connectToDevTools: process.env.NODE_ENV !== 'production',
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
});
